import '@fortawesome/fontawesome-free/css/all.min.css';

const THEME_KEY = 'theme';
const THEME_ORDER = ['system', 'light', 'dark'];
const THEME_LABELS = {
    system: 'Tema del sistema',
    light: 'Tema claro',
    dark: 'Tema oscuro',
};
const THEME_ICONS = {
    system: 'fa-circle-half-stroke',
    light: 'fa-sun',
    dark: 'fa-moon',
};

function getStoredTheme() {
    const value = localStorage.getItem(THEME_KEY);

    return value === 'light' || value === 'dark' ? value : 'system';
}

function applyTheme(theme) {
    if (theme === 'system') {
        document.documentElement.removeAttribute('data-theme');
    } else {
        document.documentElement.setAttribute('data-theme', theme);
    }

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
        const icon = button.querySelector('i');

        if (icon) {
            icon.classList.remove(...Object.values(THEME_ICONS));
            icon.classList.add(THEME_ICONS[theme]);
        }

        button.setAttribute('aria-label', THEME_LABELS[theme]);
        button.setAttribute('title', THEME_LABELS[theme]);
    });
}

document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
        const next = THEME_ORDER[(THEME_ORDER.indexOf(getStoredTheme()) + 1) % THEME_ORDER.length];

        if (next === 'system') {
            localStorage.removeItem(THEME_KEY);
        } else {
            localStorage.setItem(THEME_KEY, next);
        }

        applyTheme(next);
    });
});

applyTheme(getStoredTheme());

document.addEventListener('click', (event) => {
    const accountMenu = event.target.closest('[data-account-menu]');
    const navDropdown = event.target.closest('[data-nav-dropdown]');

    closeOpenMenus('[data-account-menu].is-open', accountMenu);
    closeOpenMenus('[data-nav-dropdown].is-open', navDropdown);

    if (accountMenu) {
        toggleMenu(accountMenu, '.account-trigger');
    }

    if (navDropdown) {
        toggleMenu(navDropdown, '.nav-dropdown-trigger');
    }
});

document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-dismiss="alert"]');

    if (close) {
        close.closest('.alert')?.remove();
    }
});

function closeOpenMenus(selector, keepOpen) {
    document.querySelectorAll(selector).forEach((el) => {
        if (el !== keepOpen) {
            el.classList.remove('is-open');
            el.querySelector('.account-trigger, .nav-dropdown-trigger')?.setAttribute('aria-expanded', 'false');
        }
    });
}

function toggleMenu(menu, triggerSelector) {
    const trigger = menu.querySelector(triggerSelector);
    const isOpen = menu.classList.toggle('is-open');

    trigger?.setAttribute('aria-expanded', String(isOpen));
}

document.querySelectorAll('.qty-update input[type="number"]').forEach((input) => {
    input.addEventListener('change', () => {
        input.closest('.qty-update')?.submit();
    });
});

document.addEventListener('submit', (event) => {
    const form = event.target.closest('.js-add-cart');

    if (!form) {
        return;
    }

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');

    button?.setAttribute('disabled', 'disabled');

    fetch(form.action, {
        method: form.method,
        headers: { Accept: 'application/json' },
        body: new FormData(form),
    })
        .then((response) => response.json())
        .then((data) => {
            setCartCount(data.count);
        })
        .finally(() => button?.removeAttribute('disabled'));
});

function setCartCount(count) {
    const link = document.querySelector('.cart-link');

    if (!link) {
        return;
    }

    let badge = link.querySelector('.cart-badge');

    if (count <= 0) {
        badge?.remove();
        return;
    }

    if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-badge';
        link.appendChild(badge);
    }

    badge.textContent = count;
    badge.classList.remove('bump');
    void badge.offsetWidth;
    badge.classList.add('bump');
}

function toggleSearchForm() {
    var btn = document.getElementById('openSearchFormBtn');
    var formw = document.querySelector('.search-form');

    if (!btn || !formw) {
        return;
    }

    btn.addEventListener('click', (event) => {
        event.preventDefault();
        formw.classList.toggle('open');
    });
}

function subcat_list() {
    var btns = document.querySelectorAll('.subcategories-toggle');

    btns.forEach(function (element) {
        element.addEventListener('click', function (ev) {
            ev.preventDefault();
            var list = ev.target.parentNode.parentNode.parentNode.nextElementSibling;
            list.classList.toggle('expanded');
        });
    });
}

function duplicateProduct() {
    var btn = document.getElementById('duplicateProduct');

    if (!btn) {
        return;
    }

    btn.addEventListener('click', function () {
        var token = document.querySelector('meta[name="csrf-token"]');

        btn.disabled = true;

        fetch(btn.dataset.url, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': token ? token.content : '',
                Accept: 'application/json',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.redirect) {
                    window.location.href = data.redirect;
                }
            })
            .finally(() => btn.removeAttribute('disabled'));
    });
}

window.toggleSearchForm = toggleSearchForm;
window.subcat_list = subcat_list;
window.duplicateProduct = duplicateProduct;
